// extracted by mini-css-extract-plugin
module.exports = {"card-swap-container":"CardSwap_card-swap-container__mI_Sx","card":"CardSwap_card__MvXkt"};